import { store } from "../store";
import { isNullUndefined } from "./utils";
import { getIdCultureUser } from "./utilsUser";

export function roundNumber(value: number) {
	return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function formatDecimal(number: number) {
	const numberString = number.toString();
	return parseFloat(numberString).toFixed(2);
}

export function formatDecimalWithPoint(number: number) {
	let numberString = number.toString();
	numberString = numberString.replace(",", ".");
	return Number(numberString);
}

export function formatTwoDecimalPlaces(number: number) {
	let numberString = number.toString();
	numberString = numberString.replace(",", ".");
	const numberArray = numberString.split(".");
	if (numberArray.length == 1) {
		numberString += "00";
	} else if (numberArray[numberArray.length - 1].length == 1) {
		numberString += "0";
	}
	numberString = numberString.replace(".", "");
	numberString = numberString.replace(/(\d{1})(\d{5})$/, "$1.$2");
	numberString = numberString.replace(/(\d{1})(\d{2})$/, "$1,$2");
	return numberString;
}

export function formatDecimalToString(v: number) {
	let vstring: string = v.toString();
	vstring = vstring.replace(",", ".");
	const vRealarray = vstring.split(".");

	if (vRealarray.length == 1) {
		vstring += "00";
	} else if (vRealarray[vRealarray.length - 1].length == 1) {
		vstring += "0";
	}

	vstring = vstring.replace(".", "");
	vstring = vstring.replace(/(\d{1})(\d{8})$/, "$1.$2");
	vstring = vstring.replace(/(\d{1})(\d{5})$/, "$1.$2");
	vstring = vstring.replace(/(\d{1})(\d{2})$/, "$1,$2");

	return vstring;
}

export function formatDecimalCommaToDot(v: number) {
	const vString = v.toString();
	const vResult = Number(vString.replace(",", "."));
	return vResult;
}

export function calculateAverage(list: number[]) {
	let average = 0;
	let total = 0;
	for (let i = 0; i < list.length; i++) {
		total += list[i];
	}
	average = total / list.length;

	return average;
}

export function formatFloatToString(v: number) {
	if (v || v === 0) {
		let vString: string = v.toString();
		vString = parseFloat(vString).toFixed(2);
		vString = vString.replace(".", "").replace(",", "");
		vString = vString.replace(/(\d{1})(\d{8})$/, "$1.$2");
		vString = vString.replace(/(\d{1})(\d{5})$/, "$1.$2");
		vString = vString.replace(/(\d{1})(\d{2})$/, "$1,$2");
		return vString;
	}
	return v;
}

export function parseStringToFloat(v?: string) {
	if (v) {
		return parseFloat(v.replace(" ", "").replace(".", "").replace(",", "."));
	}
	return 0;
}

export function convertToNumber(value: any) {
	let numberValue: number;
	try {
		numberValue = Number(value);
	} catch (error: any) {
		throw new Error(error);
	}
	return numberValue;
}

export function calculateAge(birthDate: Date, deathDate: Date | null = null) {
	const today = new Date();
	const birthDateValue = new Date(birthDate);
	const deathDateValue = deathDate !== null ? new Date(deathDate) : null;
	let age;

	if (deathDateValue == null) {
		let yearsDiff = today.getFullYear() - birthDateValue.getFullYear();
		const monthsDiff = today.getMonth() - birthDateValue.getMonth();
		const daysDiff = today.getDate() - birthDateValue.getDate();

		if (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) {
			yearsDiff -= 1;
		}

		age = yearsDiff;
	} else {
		let yearsDiff = deathDateValue.getFullYear() - birthDateValue.getFullYear();
		const monthsDiff = deathDateValue.getMonth() - birthDateValue.getMonth();
		const daysDiff = deathDateValue.getDate() - birthDateValue.getDate();

		if (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) {
			yearsDiff -= 1;
		}

		age = yearsDiff;
	}

	return age;
}

export function formatNumberWithPadding(num: number) {
	return num.toString().padStart(2, "0");
}

export function formatValueByLocaleAndCurrency(value: number, locale: string, currency: string): string {
	return value.toLocaleString(locale, {
		style: "currency",
		currency,
	});
}

export function formatValueByLocale(value: number, locale: string): string {
	return value.toLocaleString(locale);
}

// Currency method's

/**
 * @description Remove currency and convert to number
 * @param {string} value - Value to convert
 * @returns {number} Return value converted
 * @example
 * const value = '$1,000.00';
 * const valueConverted = currencyToNumber(value);
 *
 * console.log(valueConverted); // 1000.00
 *  */
export function currencyToNumber(value: string): number | null {
	const convertValue = value.replace(/[^\d.-]/g, "");
	return convertValue === "" ? null : parseFloat(convertValue);
}

/**
 * @description Format number to currency with currency simbol of user logged
 * @param {number} value - Value to format
 * @returns {string} Return value formatted
 * @example
 * const value = 1000;
 * const valueFormated = formatCurrency(value);
 *
 * console.log(valueFormated); // $ 1,000.00
 */
export function formatCurrency(value: number | null | undefined, spaceBetweenValueSymbol: boolean = false): string {
	if (isNullUndefined(value)) return "";
	const cultureUser = getIdCultureUser(); // en-US
	const currencySimbolUser = getCurrencySimbolUser(); // $
	const valueFormated: string = value.toLocaleString(cultureUser, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	if (spaceBetweenValueSymbol) {
		return `${currencySimbolUser} ${valueFormated}`;
	}
	return `${currencySimbolUser}${valueFormated}`;
}

/**
 * @description  Get Currency Simbol of User Logged
 * @returns {string}  Return Currency Simbol of User Logged
 * @example
 * const currencySimbol = getCurrencySimbolUser();
 *
 * console.log(currencySimbol); // $
 */
export function getCurrencySimbolUser() {
	const userReducer = store.getState().user;
	return userReducer.currentUser?.currencySymbol || "";
}

/**
 * @description Get Separator Thousands and Separator Decimal of User Logged
 * @returns {object}  Return Separator Thousands and Separator Decimal of User Logged
 * @example
 * const { separatorThousands, separatorDecimal } = getSeparatorDecimalByCulture(); // culture: en-US
 *
 * console.log(separatorThousands); // ,
 * console.log(separatorDecimal); // .
 */
export function getSeparatorDecimalByCulture() {
	const locale = getIdCultureUser();
	const number = 1000;

	const formattedNumber = new Intl.NumberFormat(locale).format(number);
	const separatorThousands = formattedNumber.replace(/\d+/g, "");
	const separatorDecimal = separatorThousands === "." ? "," : ".";

	return {
		separatorThousands,
		separatorDecimal,
	};
}

/**
 * This function format input to currency
 *
 * @param {string} inputValue - Value to format
 * @param oldValue  - Old value
 * @example
 * const value = '1000';
 * const valueMask = '$ 10.00';
 * const valueLeadZero = '$ 01.00';
 *
 * console.log(currencyInputMask(value)); // $ 10.00
 * console.log(currencyInputMask(valueMask)); // $ 10.00
 * console.log(currencyInputMask(valueMask)); // $ 1.00
 */
export const currencyInputMask = (inputValue: string, oldValue: string, acceptZero: boolean = false) => {
	const LEADING_ZERO = 0;
	const decimalLimit = 2;
	const integerLimit = 7;
	const currencySymbolUser = getCurrencySimbolUser();
	const { separatorDecimal, separatorThousands } = getSeparatorDecimalByCulture();

	const stripped = inputValue.replace(new RegExp(`[^\\d\\${separatorDecimal}]`, "g"), "");

	const parts = stripped.split(separatorDecimal);
	if (parts.length > 2) return oldValue;

	const hasDecimal = parts.length === 2;
	const integerRaw = parts[0] || "";
	const decimalRaw = hasDecimal ? parts[1] : "";

	if (decimalRaw.length > decimalLimit) return oldValue;
	if (integerRaw.replace(/^0+/, "").length > integerLimit) return oldValue;

	const removeLeadingZeros = integerRaw.replace(/^0+/, "");
	const integerPart =
		removeLeadingZeros.length <= LEADING_ZERO
			? removeLeadingZeros.padStart(LEADING_ZERO, "0") || "0"
			: removeLeadingZeros;

	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separatorThousands);

	const formattedValue = hasDecimal ? `${formattedInteger}${separatorDecimal}${decimalRaw}` : formattedInteger;

	const numericCheck = Number(`${integerPart}.${decimalRaw || "0"}`);
	const isDecimalZero = decimalRaw === "00";
	if (
		isNaN(numericCheck) ||
		formattedValue === "" ||
		(!acceptZero && numericCheck === 0 && (!hasDecimal || isDecimalZero))
	) {
		return "";
	}

	return `${currencySymbolUser} ${formattedValue}`;
};

/**
 * @description This function add px to value
 * @param {number} value - Value to append px
 * @returns {string} Return value with px
 * @example
 * const value:number = 100;
 * const valueWithPx = addPx(value);
 * console.log(valueWithPx); // 100px (string)
 */
export function formatAsPx(value: number) {
	return value + "px";
}

export function calculateVolume(height: number, width: number, depth: number): number {
	return (height * width * depth) / 1000;
}

export function ipToNumber(ip: string) {
	const segments = ip.split(".").map(Number);
	return segments[0] * 256 ** 3 + segments[1] * 256 ** 2 + segments[2] * 256 + segments[3];
}

export function formatPercentage(number: number) {
	return `${number}%`;
}
export function addLeadingZero(number: number): string {
	return number < 10 ? `0${number}` : `${number}`;
}

export function inRange(value: number, limitA: number, limitB: number): boolean {
	return (value - limitA) * (value - limitB) <= 0;
}

export function inRangeExclusive(value: number, limitA: number, limitB: number): boolean {
	return (value - limitA) * (value - limitB) < 0;
}
